var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateElement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_duplicate_3258923") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell/Course",
    transform: "translate(-198.000000, -161.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(188.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_duplicate_3258923",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2857143,5.14285714 L18.8571429,5.14285714 L18.8571429,1.71428571 C18.8560565,0.767962224 18.0891806,0.00108639905 17.1428571,0 L1.71428571,0 C0.767962224,0.00108639905 0.00108639905,0.767962224 0,1.71428571 L0,17.1428571 C0.00108639905,18.0891806 0.767962224,18.8560565 1.71428571,18.8571429 L5.14285714,18.8571429 L5.14285714,22.2857143 C5.14394354,23.2320378 5.91081937,23.9989136 6.85714286,24 L22.2857143,24 C23.2320378,23.9989136 23.9989136,23.2320378 24,22.2857143 L24,6.85714286 C23.9989136,5.91081937 23.2320378,5.14394354 22.2857143,5.14285714 Z M2,2 L16.9991667,2 L16.9991667,6.16558333 L16.9991667,6.16666667 L16.9991667,6.16775 L17,17 L2,17 L2,2 Z M22,22 L7,22 L7,18.6666667 L17,18.6666667 C17.9200367,18.6656104 18.6656104,17.9200367 18.6666667,17 L18.6666667,7 L22,7 L22,22 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateElement);
export default __webpack_public_path__ + "static/media/duplicate-element.7f227be19c72ad63fffd573bb8c5e029.svg";
export { ForwardRef as ReactComponent };